import { Anchor, Card, Group, Loader, Stack, Text, Title } from '@mantine/core';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useSessionGroupResearchUsages } from '../hooks/useSessionGroupResearchUsages';
import { buildSpectralAnalysisHref } from '../utils/buildGroupSessionHref';

const formatDate = (value?: string | null) => {
  if (!value) return 'n/a';
  return new Date(value).toLocaleString('it-IT');
};

type SessionGroupResearchUsagesCardProps = {
  groupId: string;
};

export function SessionGroupResearchUsagesCard({
  groupId,
}: SessionGroupResearchUsagesCardProps) {
  const { usages, isLoading, error } = useSessionGroupResearchUsages(groupId);

  return (
    <Card withBorder>
      <Stack gap='sm'>
        <div>
          <Title order={4}>Usato in ricerca</Title>
          <Text size='sm' c='dimmed' mt={4}>
            Analisi di normalizzazione spettrale che usano questo gruppo come
            sorgente sessioni.
          </Text>
        </div>

        {isLoading ? (
          <Group justify='center' py='md'>
            <Loader size='sm' />
          </Group>
        ) : error ? (
          <Text c='red' size='sm'>
            {error instanceof Error
              ? error.message
              : 'Impossibile caricare le analisi collegate.'}
          </Text>
        ) : usages.length === 0 ? (
          <Text size='sm' c='dimmed'>
            Nessuna analisi collegata a questo gruppo.
          </Text>
        ) : (
          <Stack gap='sm'>
            {usages.map(usage => (
              <Card key={usage.analysisId} withBorder padding='md' radius='md'>
                <Group justify='space-between' align='flex-start' wrap='nowrap'>
                  <Stack gap={4} style={{ flex: 1, minWidth: 0 }}>
                    <Title order={5}>{usage.name}</Title>
                    {usage.description && (
                      <Text size='sm' c='dimmed' lineClamp={2}>
                        {usage.description}
                      </Text>
                    )}
                    <Text size='xs' c='dimmed'>
                      {usage.sessionCount} sessioni · Aggiornata{' '}
                      {formatDate(usage.updatedAt)}
                    </Text>
                  </Stack>
                  <Anchor
                    component={Link}
                    to={buildSpectralAnalysisHref(usage.analysisId)}
                    size='sm'
                    style={{ whiteSpace: 'nowrap' }}
                  >
                    <Group gap={4} wrap='nowrap'>
                      Apri analisi
                      <ArrowRight size={14} />
                    </Group>
                  </Anchor>
                </Group>
              </Card>
            ))}
          </Stack>
        )}
      </Stack>
    </Card>
  );
}
